import type { Action as ReduxAction } from 'redux';
import { BATCH, type BatchAction } from 'redux-batched-actions';
import { Observable } from 'rxjs/Observable';
import { PARENT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import { EpicPanelRefetchStore } from '@atlassian/jira-software-backlog-panel/src/services/epic-panel-refetch/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { defaultRegistry } from '@atlassian/react-sweet-state';
import { REFRESH_DATA_REQUEST } from '../../state/actions/app/index.tsx';
import {
	type CardSetIndividualResponseSuccessAction,
	CARD_SET_INDIVIDUAL_REQUEST_SUCCESS,
} from '../../state/actions/card-set-request/index.tsx';
import { CARD_CREATE_SUCCESS } from '../../state/actions/cards/create/index.tsx';
import { CARD_DELETE_SUCCESS } from '../../state/actions/cards/delete/index.tsx';
import type { ActionsObservable } from '../../state/types.tsx';

const isCardSetIndividualResponse = (
	action: ReduxAction,
): action is CardSetIndividualResponseSuccessAction =>
	action.type === CARD_SET_INDIVIDUAL_REQUEST_SUCCESS;

const isBatchCardParentSetSuccess = (batchAction: BatchAction) =>
	batchAction.payload.some(
		(action) => isCardSetIndividualResponse(action) && action.payload.fieldId === PARENT_TYPE,
	);

const REFETCH_EPIC_PANEL_DEBOUNCE_MS = 500;
export const refetchEpicPanelEpic = (action$: ActionsObservable) =>
	action$
		.ofType(REFRESH_DATA_REQUEST, CARD_CREATE_SUCCESS, CARD_DELETE_SUCCESS, BATCH)
		.debounceTime(REFETCH_EPIC_PANEL_DEBOUNCE_MS)
		.switchMap((action) => {
			if (action.type === BATCH && !isBatchCardParentSetSuccess(action)) {
				return Observable.empty<never>();
			}

			const epicPanelRefetchStoreInstance = defaultRegistry.getStore(EpicPanelRefetchStore);
			const { triggerEpicPanelRefetch } = epicPanelRefetchStoreInstance.actions;
			triggerEpicPanelRefetch();
			return Observable.empty<never>();
		});
